import type { JSX } from 'react'

import * as era from '~/core/era'
import { ui } from '~/core/skin'

const skin = era.skin('routes/partner-program/details')

PartnerProgramDetailsPage.displayName = 'PartnerProgramDetailsPage'
export function PartnerProgramDetailsPage(): JSX.Element {
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper>
        <ui.RenderSkin name='partnerProgramDetails' />
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
